//
import { Map as ImmutableMap, Record } from 'immutable';

export const mkStdForm = Record({
  id: '0',
  type: 'StdForm',

  cancelled: false,
  submitSucceeded: false,
  submitFailed: false,
  submitResponseData: null,
});

export const mkStdFormsStore = Record({
  stdFormsById: ImmutableMap(),
});
